import React from "react";
import DashboardCard from "../../pages/home/common/DashboardCard";
import { formattedAmount } from "../common-data/Converts";

const CTOCards = ({ stats }) => {
  return (
    <div className="cards-container cards-grid-container grid-4 mt-2rem">
      <DashboardCard
        tagName={"cto"}
        cardLabel={"CTO"}
        value={stats?.totalCto ? `${formattedAmount(stats.totalCto)}` : `0`}
        valueAcheived={
          stats?.cto_acheived ? `₹${formattedAmount(stats.cto_acheived)}` : `₹0`
        }
      />

      {/* <DashboardCard
        tagName={"cto-acheived"}
        cardLabel={"CTO acheived"}
        value={
          stats?.cto_acheived ? `₹${formattedAmount(stats.cto_acheived)}` : `₹0`
        }
      /> */}

      <DashboardCard
        tagName={"monthly-target"}
        cardLabel={"monthly overall target"}
        value={
          stats?.target_value ? `${formattedAmount(stats.target_value)}` : `0`
        }
        valueAcheived={
          stats?.target_value_acheived
            ? `₹${formattedAmount(stats.target_value_acheived)}`
            : `₹0`
        }
        valueRemaining={
          stats?.remaining_target
            ? `${formattedAmount(stats.remaining_target)}`
            : `0`
        }
      />

      <DashboardCard
        tagName={"regular-target"}
        cardLabel={"Monthly Regular Target"}
        value={
          stats?.regular_member_target?.total
            ? `${formattedAmount(stats.regular_member_target.total)}`
            : `0`
        }
        valueAcheived={
          stats?.regular_member_target?.acheived
            ? `₹${formattedAmount(stats.regular_member_target.acheived)}`
            : `₹0`
        }
        valueRemaining={
          stats?.regular_member_target?.remaining
            ? `${formattedAmount(stats.regular_member_target.remaining)}`
            : `0`
        }
      />

      <DashboardCard
        tagName={"pt-target"}
        cardLabel={"Monthly PT Target"}
        value={
          stats?.pt_membership_target?.total
            ? `${formattedAmount(stats.pt_membership_target.total)}`
            : `0`
        }
        valueAcheived={
          stats?.pt_membership_target?.acheived
            ? `₹${formattedAmount(stats.pt_membership_target.acheived)}`
            : `₹0`
        }
        valueRemaining={
          stats?.pt_membership_target?.remaining
            ? `${formattedAmount(stats.pt_membership_target.remaining)}`
            : `0`
        }
      />

      {/* <DashboardCard
        tagName={"target-acheived"}
        cardLabel={"target acheived"}
        value={
          stats?.target_value_acheived
            ? `₹${formattedAmount(stats.target_value_acheived)}`
            : `₹0`
        }
      /> */}
    </div>
  );
};

export default CTOCards;
